import { keyframes, styled } from '../styled-components'

const ringAnimation = keyframes`
  0% {
      transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const Loading = styled.div`
  display: block;
  width: 64px;
  height: 64px;
  margin: 20px auto;
  &:after {
    content: " ";
    display: block;
    width: 46px;
    height: 46px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${props => props.theme.primaryColor};
    border-color: ${props => props.theme.primaryColor} transparent ${props => props.theme.primaryColor} transparent;
    animation: ${ringAnimation} 1.2s linear infinite;
  }
`
